import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import categoriesData from '../../functions/Categories.json';
import '../../styles/homeCategories.css';
import { db } from '../../firebase';
import { doc, getDoc } from 'firebase/firestore';

const ExploreWorldCategories = () => {
  const cardsContainerRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  const [bannerImage, setBannerImage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);

    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  // Fetch Explore World banner image from Firestore
  useEffect(() => {
    async function fetchBannerImage() {
      try {
        const docRef = doc(db, "Images", "AllImages");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists() && docSnap.data()["Explore World"] && docSnap.data()["Explore World"].url) {
          setBannerImage(docSnap.data()["Explore World"].url);
        }
      } catch (error) {
        // fallback: do nothing
      }
    }
    fetchBannerImage();
  }, []);

  const scrollLeft = () => {
    if (cardsContainerRef.current) {
      cardsContainerRef.current.scrollLeft -= 250;
    }
  };

  const scrollRight = () => {
    if (cardsContainerRef.current) {
      cardsContainerRef.current.scrollLeft += 250;
    }
  };

  const handleCardClick = (location) => {
    window.scrollTo(0, 0);
    navigate(`/destinations?location=${encodeURIComponent(location.toLowerCase())}`);
  };

  return (
    <div className="category-outer-container explore-world-outer">
      <div className="category-container">
        <div
          className="category-banner"
          style={{
            backgroundImage: bannerImage
              ? `url('${bannerImage}')`
              : "url('https://images.unsplash.com/photo-1464802686167-b939a6910659?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80')"
          }}
        >
          <div className="category-banner-content">
            <h1 className="category-banner-h1" style={{ fontSize: isMobile ? '1.8em' : '2.5em' }}>Explore World</h1>
            <p className="category-banner-p">Discover Continents, Cultures, and Wonders</p>
            <a
              href="#"
              className="category-explore-button"
              style={{ backgroundColor: '#ffeb3b', color: '#333' }}
              onClick={(e) => {
                e.preventDefault();
                navigate('/destinations?location=international');
                window.scrollTo(0, 0);
              }}
            >
              Explore
            </a>
          </div>
        </div>
      </div>

      <button
        className="nav-arrow nav-left"
        onClick={scrollLeft}
        aria-label="Scroll left"
      >
        <span className="arrow-icon" style={{ backgroundColor: '#FFD700' }}>
          <i className="fas fa-chevron-left"></i>
        </span>
      </button>

      <button
        className="nav-arrow nav-right"
        onClick={scrollRight}
        aria-label="Scroll right"
      >
        <span className="arrow-icon" style={{ backgroundColor: '#FFD700' }}>
          <i className="fas fa-chevron-right"></i>
        </span>
      </button>

      <div className="category-cards-overlay" ref={cardsContainerRef}>
        {categoriesData.International.filter(dest => dest.img && dest.price).map((destination, index) => (
          <div
            key={index}
            className="destination-card"
            onClick={() => handleCardClick(destination.name)}
            role="button"
            tabIndex={0}
          >
            <img src={destination.img} alt={destination.name} className="destination-card-img" />
            <div className="card-info">
              <h3 className="card-info-h3">{destination.name}</h3>
              {/* <p className="card-info-p">{destination.price}</p> */}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExploreWorldCategories;
